module.exports = __webpack_public_path__ + "static/media/Maf_16Julio.820ea0b3.jpg";